import React, { useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import Home from './pages/Home';
import Experience from './pages/Experience';
import Skills from './pages/Skills';
import Projects from './pages/Projects';
import Education from './pages/Education';
import NotFound from './pages/NotFound';
import BootSequence from './components/BootSequence';
import Terminal from './components/Terminal';
import Analytics from './components/Analytics';
import { prefersReducedMotion } from './lib/motion';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Theme */
import './theme/variables.css';
import './theme/global.css';

setupIonicReact();

const App: React.FC = () => {
  const [hasBooted, setHasBooted] = useState(() => {
    return prefersReducedMotion() || sessionStorage.getItem('hasBooted') === 'true';
  });

  const handleBootComplete = () => {
    sessionStorage.setItem('hasBooted', 'true');
    setHasBooted(true);
  };

  return (
    <IonApp>
      {!hasBooted && <BootSequence onComplete={handleBootComplete} />}
      <div className="crt-bg" />
      <IonReactRouter>
        <IonRouterOutlet>
          <Switch>
            <Route exact path="/home" component={Home} />
            <Route exact path="/experience" component={Experience} />
            <Route exact path="/skills" component={Skills} />
            <Route exact path="/projects" component={Projects} />
            <Route exact path="/education" component={Education} />
            <Route exact path="/certifications">
              <Redirect to="/education" />
            </Route>
            <Route exact path="/">
              <Redirect to="/home" />
            </Route>
            <Route component={NotFound} />
          </Switch>
        </IonRouterOutlet>
      </IonReactRouter>
      <Terminal />
      <Analytics />
    </IonApp>
  );
};

export default App;
